import type { FaireProductEntity } from "../../entity_types/product";

export const p_7qfb7pfqbm: FaireProductEntity = {
  token: "p_7qfb7pfqbm",
  type: "product",
  name: "Pink Contrast Striped Collar Patchwork Puff Sleeve Ruffle Hem Mini Dress",
  brandToken: "b_fkehs24v39",
  brandName: "Sweet Lover Fashion",
  imageUrl:
    "https://cdn.faire.com/fastly/a23fa6eec5dd2f35c66569e96fc13a9797c0048c42f9bba7d9c2b4ab2c0bea41.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4db91c20d3bcb0a8a5afe13598d5acd26182770b092dfea5c889efb2d8570869.jpeg",
  ],
  priceDollars: 18.85,
  description:
    "Bold contrast striped collar adds a preppy, eye-catching touch to this playful mini dress.\nThe patchwork collar design brings trendy, standout vibes perfect for seasonal styling.\nVoluminous puff sleeves create a feminine silhouette with added vintage flair.\nFlirty ruffle hemline enhances movement and gives a fun, youthful finish.\n",
  tags: [],
  msrpDollars: 37.7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:11.363Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
